import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usageActions from '../../../Actions/Voss/usageActions';
import CustomerUsage from '../../../Components/Customer/VOSS/Usage/CustomerUsage';
import type { UsageReducerState } from '../../../Reducers/Voss/UsageReducer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyDispatch = any;

interface RootState {
    CustomerReducer: {
        customer: {
            vossCustomer?: { id: string } | null;
        };
    };
    UsageReducer: UsageReducerState;
    CommonReducer: {
        dataLoading: Record<string, boolean | undefined>;
    };
}

const UsageContainer = () => {
    const dispatch: AnyDispatch = useDispatch();
    const customer = useSelector((state: RootState) => state.CustomerReducer.customer);
    const usage = useSelector((state: RootState) => state.UsageReducer.customerUsage);
    const isLoading = useSelector((state: RootState) => state.CommonReducer.dataLoading.customerUsage === true);

    const vossCustomerId = customer.vossCustomer?.id;

    useEffect(() => {
        if (vossCustomerId !== undefined && vossCustomerId !== null) {
            dispatch(usageActions.getCustomerUsage(vossCustomerId));
        }
        return () => {
            dispatch(usageActions.clearCustomerUsage());
        };
    }, [dispatch, vossCustomerId]);

    if (vossCustomerId === undefined || vossCustomerId === null) return null;

    if (usage?.isApplicable !== true) return null;

    return <CustomerUsage usage={usage} isLoading={isLoading} />;
};

export default UsageContainer;
